import React from "react"
import { discountOffer } from "../../utils/exchangeOffer"
import apiFetcher from "../../utils/apiFetcher"
import { useState, useEffect } from "react"
export const DiscountOption = ({service,price,discount, setError, setBought}) => {

    const handleClick = async  (e) => {
        const {service, price, discount} = e.target.dataset;
        const discountData = {
            service: service,
            price: price,
            discount: discount
        }
        const success = await apiFetcher.buyDiscount(discountData)
        if(!success) {
            setError(`Masz za mało punktów aby kupić tą zniżkę.`)
            return;
        }
        setBought(true);
        setError(``)

    }

    return (
        <div className="offer-panel">
            <img width="512" height="512" loading="lazy" src="photos/gift-voucher.webp" alt={`Zniżka na ${service} - ${discount}zł`}></img>
            <p>Usługa: <b>{service}</b></p>
            <p>Zniżka: -<b>{discount}zł</b></p>
            <p>Koszt: <b>{price} punktów</b></p>
            <button onClick={(e) => {
                e.target.dataset.service = service;
                e.target.dataset.price = price;
                e.target.dataset.discount = discount;
                handleClick(e)
            }}><h3>Kup</h3></button>
        </div>
    )
}

const Discount = ({service, discount,code}) => {

   

    return (
        <div className="offer-panel">
            <p><b>Bon zniżkowy</b></p>
            <p>Usługa: {service}</p>
            <p>Zniżka: -<b>{discount}zł</b></p>
            <p>Kod zniżkowy: <b>{code}</b></p>
        </div>
    )

    


}




const DiscountExchange = ({isLoggedIn, setPoints, points}) => {
    const [error,setError] = useState(``)
    const [bought, setBought] = useState();
    const [discounts, setDiscounts] = useState(false);
    const getDiscounts = async () => {
        try {
            const discounst = await apiFetcher.getDiscounts();
            if(!discounst) return;
            setDiscounts(discounst)
        }catch(error) {
            console.log(error)
            throw error
        }

    }

    useEffect(() => {
        getDiscounts();
    },[])

    useEffect(() => {
        if(!bought) return;
        getDiscounts();
        setBought(false)
    },[bought])

    return (
    <>

    {isLoggedIn 
        ?

        <>
         <>

        {discounts.length > 0 ?
                <>
                <div className="discount-offer-header">
                <b>Twoje aktualne zniżki</b>
                </div>
                <div className="discount-flex-container">
                <div className="bon-section">
                {discounts.map((value,i) => (
                    <Discount key={i}
                    service={value.service}  
                    discount={value.discount}
                    code={value.discountCode}
                    />
                )) }

            </div>
            </div>
            </>

        : <div></div>}

        </>
        <div style={{borderBottom: "solid #ffc107", marginTop: "2%"}}>
        <div className="discount-offer-header">
        <b>Zapoznaj się z naszą ofertą zniżek!</b>

        </div>
        <div className="points-error">
        <p><b>{error}</b></p>
        </div>

        <div  className="bon-section">
            {discountOffer.map((value,i) => (
                <DiscountOption key={i}
                service={value.service}  
                price={value.price}
                discount={value.discount}
                setError={setError}
                setBought={setBought}
                points={points}
                setPoints={setPoints}
                />
            )) }

        </div>
       

    </div>
    </>
         : null}
      </>
    )


}


export default DiscountExchange